/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ItemExhibitionWithRelations } from '../../models/item-exhibition-with-relations';

export interface AdminGetExhibitionsListForItem$Params {
  id: string;
  inventoryId: string;
}

export function adminGetExhibitionsListForItem(http: HttpClient, rootUrl: string, params: AdminGetExhibitionsListForItem$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ItemExhibitionWithRelations>>> {
  const rb = new RequestBuilder(rootUrl, adminGetExhibitionsListForItem.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('inventoryId', params.inventoryId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ItemExhibitionWithRelations>>;
    })
  );
}

adminGetExhibitionsListForItem.PATH = '/admin/items/{id}/exhibitions';
